function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 705 479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 705,
    height: 479,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "portada-web-streaming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.87,228.52c.09-1.16.23-2.32.41-3.47l59.12,59.1c-1.15.18-2.31.31-3.47.41Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.93,274.14c-.74.57-1.49,1.11-2.26,1.63l-72-72c.53-.77,1.07-1.52,1.63-2.26Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.07,181.14c1.4.05,2.79.14,4.18.3L590,227.16c.16,1.39.26,2.79.3,4.18Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.38,282c-1,.33-2,.63-3,.91l-63.84-63.81c.27-1,.57-2,.91-3Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.83,211.83a51.85,51.85,0,0,1,2.31,6.19l-34.75-34.73a51.15,51.15,0,0,1,6.19,2.3Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.54,195.61l73.29,73.26c-.22.24-.44.48-.67.71-.42.42-.85.82-1.28,1.22l-73.26-73.23c.4-.43.8-.86,1.22-1.29Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.14,278.54c-.85.46-1.7.9-2.57,1.3l-69-69c.41-.87.84-1.72,1.3-2.57Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.76,284.68c-1.44-.08-2.87-.21-4.3-.41L487.16,240c-.19-1.43-.33-2.86-.41-4.3Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.89,262.76c-.53.75-1.08,1.49-1.66,2.22l-72.8-72.77c.73-.57,1.48-1.12,2.23-1.66Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,238.38c-.12,1.14-.29,2.28-.48,3.41l-59.93-59.91c1.13-.2,2.26-.36,3.4-.48Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.19,256.19a52.26,52.26,0,0,1-2.79-6.67L521.93,282a50.8,50.8,0,0,1-6.67-2.78Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.19,247.71c-.29,1-.62,1.95-1,2.91l-66.43-66.4c1-.35,1.93-.68,2.91-1Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.05,255.74c-.42.86-.87,1.71-1.34,2.55l-70.58-70.56c.84-.47,1.69-.91,2.54-1.34Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.87,372.52c.09-1.16.23-2.32.41-3.47l59.12,59.1c-1.15.18-2.31.31-3.47.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,418.14c-.74.57-1.49,1.11-2.26,1.63l-72-72c.53-.77,1.07-1.52,1.63-2.26Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,325.14c1.4.05,2.79.14,4.18.3L217,371.16c.16,1.39.26,2.79.3,4.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,426c-1,.33-2,.63-3,.91l-63.84-63.81c.27-1,.57-2,.91-3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,355.83a51.85,51.85,0,0,1,2.31,6.19l-34.75-34.73a51.15,51.15,0,0,1,6.19,2.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.54,339.61l73.29,73.26c-.22.24-.44.48-.67.71-.42.42-.85.82-1.28,1.22l-73.26-73.23c.4-.43.8-.86,1.22-1.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14,422.54c-.85.46-1.7.9-2.57,1.3l-69-69c.41-.87.84-1.72,1.3-2.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,428.68c-1.44-.08-2.87-.21-4.3-.41L114.16,384c-.19-1.43-.33-2.86-.41-4.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.89,406.76c-.53.75-1.08,1.49-1.66,2.22l-72.8-72.77c.73-.57,1.48-1.12,2.23-1.66Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,382.38c-.12,1.14-.29,2.28-.48,3.41l-59.93-59.91c1.13-.2,2.26-.36,3.4-.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19,400.19a52.26,52.26,0,0,1-2.79-6.67L148.93,426a50.8,50.8,0,0,1-6.67-2.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,391.71c-.29,1-.62,2-1,2.91l-66.43-66.4c1-.35,1.93-.68,2.91-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,399.74c-.42.86-.87,1.71-1.34,2.55l-70.58-70.56c.84-.47,1.69-.91,2.54-1.34Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.65,135.64l-1.32.13q-1.69.18-3.48.45c-21,3.19-50.24,15.86-60,43.86L-61.62,88.84,44.24,39.58a48.07,48.07,0,0,1,48.69,4.47c.58.43,1.16.88,1.73,1.34s1,.86,1.53,1.31C125.32,72.44,118.26,129.23,45.65,135.64Z",
    style: {
      fill: "#373435"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,46.7c-12.77,4.63-25.81,11.83-35.73,23C46,86,40.56,108.05,44.25,135.18c0,.2,0,.4.08.59,8.09,61.39-27,73.75-37.93,76.07a57,57,0,0,1-24.09-.38,67.58,67.58,0,0,1-16.66-6.14l.79-3.54c12.6,6.83,26.86,9.27,39.24,6.63,27.24-5.77,40.37-32.74,35.17-72.19,0-.19,0-.37-.07-.56C37,107.46,42.69,84.49,57.85,67.39c9.9-11.17,22.57-18.51,35.08-23.34.58.43,1.16.88,1.73,1.34S95.69,46.25,96.19,46.7Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662,355.29l1.32-.13q1.69-.18,3.48-.45c21-3.19,50.24-15.86,60-43.86l42.46,91.24L663.36,451.35a48.07,48.07,0,0,1-48.69-4.47c-.58-.43-1.16-.88-1.73-1.34s-1-.86-1.53-1.31C582.28,418.49,589.34,361.7,662,355.29Z",
    style: {
      fill: "#373435"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.41,444.23c12.77-4.63,25.81-11.83,35.73-23,14.44-16.3,19.9-38.33,16.21-65.46,0-.2-.05-.4-.08-.59-8.09-61.39,27-73.75,37.93-76.07a57,57,0,0,1,24.09.38A67.58,67.58,0,0,1,742,285.61l-.79,3.54c-12.6-6.83-26.86-9.27-39.24-6.63-27.24,5.77-40.37,32.74-35.17,72.19,0,.19,0,.37.07.56,3.83,28.2-1.91,51.17-17.07,68.27-9.9,11.17-22.57,18.51-35.08,23.34-.58-.43-1.16-.88-1.73-1.34S611.91,444.68,611.41,444.23Z",
    style: {
      fill: "#ff0e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.08,423.21a7.41,7.41,0,1,1,7.06-7.74A7.41,7.41,0,0,1,504.08,423.21Z",
    style: {
      fill: "#74777c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.11,334.69a2.4,2.4,0,1,1,2.28-2.51A2.42,2.42,0,0,1,331.11,334.69Z",
    style: {
      fill: "#74777c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.53,169.93a4.74,4.74,0,1,1,4.51-5A4.74,4.74,0,0,1,295.53,169.93Z",
    style: {
      fill: "#74777c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.95,
    cy: 341.6,
    r: 6.84,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.88,250a5.29,5.29,0,1,1,5-5.53A5.3,5.3,0,0,1,150.88,250Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.17,
    cy: 451.1,
    r: 4.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.84,252.16a3.21,3.21,0,1,1,3.06-3.36A3.21,3.21,0,0,1,394.84,252.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.84,120.16a3.21,3.21,0,1,1,3.06-3.36A3.21,3.21,0,0,1,604.84,120.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.71,
    cy: 409.86,
    r: 6.77,
    style: {
      fill: "#ea0029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,168.83a6.3,6.3,0,1,1,6-6.58A6.3,6.3,0,0,1,392.06,168.83Z",
    style: {
      fill: "#ea0029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.06,281.83a6.3,6.3,0,1,1,6-6.58A6.3,6.3,0,0,1,263.06,281.83Z",
    style: {
      fill: "#ea0029"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.77,86.29a3.06,3.06,0,1,1,2.92-3.19A3.05,3.05,0,0,1,304.77,86.29Z",
    style: {
      fill: "#ea0029"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.81,
    cy: 281.75,
    r: 3.51,
    style: {
      fill: "#d61900"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.47,
    cy: 177.71,
    r: 4.31,
    style: {
      fill: "#f41400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.33,150a4,4,0,1,1,3.77-4.13A4,4,0,0,1,221.33,150Z",
    style: {
      fill: "#f41400"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.0853878ff91565c665f3f63bf7b6b8ea.svg";
export { ForwardRef as ReactComponent };